import React from 'react';
import { MapPin, MessageCircle, Instagram, Music2 } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black pt-16 pb-8 px-5 md:px-8 border-t border-arena/5" data-id="element-110">
      <div className="max-w-[1180px] mx-auto" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16" data-id="element-112">
          {/* Col 1 */}
          <div data-id="element-113">
            <div className="flex items-center gap-3 mb-3" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/thWu2RCgaRu46HPvan8vVY/Isotipo_black_puro.png" alt="Quebrada Digital isotipo" className="h-10 md:h-12 w-auto" data-id="element-115" />
              <h3 className="font-playfair text-ambar text-xl md:text-[1.3rem] font-bold" data-id="element-116">
                Quebrada Digital
              </h3>
            </div>
            <p className="font-nunito text-arena/40 text-sm max-w-[250px]" data-id="element-117">
              Presencia digital para los que se la juegan.
            </p>
          </div>

          {/* Col 2 */}
          <div data-id="element-118">
            <h4 className="font-nunito text-arena/80 text-sm font-bold uppercase tracking-wider mb-4" data-id="element-119">
              Secciones
            </h4>
            <ul className="space-y-3" data-id="element-120">
              {['Inicio', 'Servicios', 'Nosotros', 'Contacto'].map(item => <li key={item} data-id="element-121">
                  <a href={item === 'Inicio' ? '#' : `#${item.toLowerCase()}`} className="font-nunito text-arena/55 text-sm hover:text-ambar transition-colors duration-250" data-id="element-122">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-123">
            <h4 className="font-nunito text-arena/80 text-sm font-bold uppercase tracking-wider mb-4" data-id="element-124">
              Contacto
            </h4>
            <ul className="space-y-3" data-id="element-125">
              <li className="font-nunito text-arena/55 text-sm flex items-center gap-2" data-id="element-126">
                <MessageCircle size={16} className="text-terracota" data-id="element-127" /> WhatsApp
              </li>
              <li className="font-nunito text-arena/55 text-sm flex items-center gap-2" data-id="element-128">
                <MapPin size={16} className="text-terracota" data-id="element-129" /> Tilcara, Jujuy
              </li>
              <li data-id="element-130">
                <a href="https://www.instagram.com/quebradadigital.tilcara" target="_blank" rel="noopener noreferrer" className="font-nunito text-arena/55 text-sm flex items-center gap-2 hover:text-ambar transition-colors duration-250" data-id="element-131">
                  <Instagram size={16} className="text-terracota" data-id="element-132" />{' '}
                  @quebradadigital.tilcara
                </a>
              </li>
              <li data-id="element-133">
                <a href="https://www.tiktok.com/@quebradadigital22" target="_blank" rel="noopener noreferrer" className="font-nunito text-arena/55 text-sm flex items-center gap-2 hover:text-ambar transition-colors duration-250" data-id="element-134">
                  <Music2 size={16} className="text-terracota" data-id="element-135" />{' '}
                  @quebradadigital22
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-arena/10 text-center" data-id="element-136">
          <p className="font-nunito text-arena/30 text-sm" data-id="element-137">
            © {new Date().getFullYear()} Quebrada Digital. Hecho con orgullo en
            la Quebrada.
          </p>
        </div>
      </div>
    </footer>;
}